import urls from "@/constants/urls.js";
import axios from "axios";
import { ref } from "vue";
import { useTeamLeaderContacts } from "@/composables/useDashboardTeamLeaderContacts";

async function getProtectedMyTeams(params) {
  const { campaignId: cId } = useTeamLeaderContacts();
  const orgId = localStorage.getItem("orgId");

  const { data } = await axios.get(
    urls.apiTeams.replace(":orgId", orgId).replace(":campaignId", cId.value),
    {
      params,
    }
  );

  return data;
}

export function useProctectedMyTeamsList() {
  const teams = ref([]);
  const loading = ref(false);

  async function fetchProtectedMyTeams(params) {
    loading.value = true;

    try {
      const { data } = await getProtectedMyTeams(params);

      teams.value = data;

      return data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return {
    teams,
    loading,
    fetchProtectedMyTeams,
  };
}
